import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DockingBarService, DsModalService } from '@amfam/ui-kit';

import * as addVehicleFeatureSelector from '../+state/add-vehicle-feature.selectors';
import { AddVehicleContainerComponent } from '../add-vehicle-container/add-vehicle-container.component';

@Injectable({
  providedIn: 'root'
})
export class AddVehicleFeatureGuardGuard {
  constructor(
    private modalService: DsModalService,
    private dockingBarService: DockingBarService,
    private store: Store
  ) {}
  canDeactivate(
    component: AddVehicleContainerComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.select(addVehicleFeatureSelector.selectAddVehicleExitFlowStatus).pipe(
      map(exitStatus => {
        /** AS: If you are not navigating to one of the add vehicle screens or the current page
         * is not a confirmation page or you haven't clicked on exit navigation from the modal screen
         * do not let the customer exit out of the flow.
         */
        if (
          nextState.url.indexOf('add-vehicle') !== -1 ||
          state.url.indexOf('confirmation') !== -1 ||
          state.url.indexOf('expectation') !== -1 ||
          state.url.indexOf('year-vin') !== -1 ||
          exitStatus
        ) {
          return true;
        } else {
          this.modalService.open(component.exitFlowModalId);
          return false;
        }
      })
    );
  }
}
